/**
 * Retrieve item from localStorage with a lazy expiry calculation.
 *
 * @param {string} key the string name of the variable to retrieve.
 */
const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date().getTime();
  // compare the expiry time of the item with the current time
  if (now > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

for (let i = 0; i < localStorage.length; i++) {
  const key = localStorage.key(i);

  if (key && key.startsWith('Emory.commerce.order.')) {
    let storedParam = getWithExpiry(key);
    if (storedParam) {
      let paramName = key.replace("Emory.commerce.order.", "");
      let appealInput = document.getElementById('_'+paramName);
      // console.log('_'+paramName);
      appealInput.value = storedParam;
    }
  }
}
